import Icon from '../components/Icon.vue'

Icon.register({
  campground: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 448c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-608c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h24.7l239.8-330.3-53.4-73.5c-5.2-7.2-3.6-17.2 3.5-22.4l25.9-18.8c7.1-5.2 17.2-3.6 22.3 3.5l41.2 56.7 41.2-56.7c5.2-7.2 15.2-8.7 22.3-3.6l25.9 18.8c7.1 5.2 8.7 15.2 3.5 22.4l-53.4 73.5 239.8 330.3h24.7zM320 288l-116.4 160h232.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/campground.js
// module id = 1144
// module chunks = 0